import React, { useRef } from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import tituloKawaii from "../../assets/images/svg/tituloKawaii.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "./index.css";
import setaEsquerda from "../../assets/images/svg/setaEsquerda.svg";
import setaDireita from "../../assets/images/svg/setaDireita.svg";
import texto4 from "../../assets/images/svg/texto4.svg";
import texto5 from "../../assets/images/svg/texto5.svg";
import pelucia1 from "../../assets/images/png/pelucias/Animal Crossing Mocchi.png";
import pelucia2 from "../../assets/images/png/pelucias/Animal Hello Kitty.png";
import pelucia3 from "../../assets/images/png/pelucias/Axolotl Hello Kitty.png";
import pelucia4 from "../../assets/images/png/pelucias/Beetlejuice.png";
import pelucia5 from "../../assets/images/png/pelucias/Bluey Squishy Cloud.png";
import pelucia6 from "../../assets/images/png/pelucias/Carebear Hello Kitty.png";
import pelucia7 from "../../assets/images/png/pelucias/Dragon Hello Kitty.png";
import pelucia8 from "../../assets/images/png/pelucias/Fruit Hello Kitty.png";
import pelucia9 from "../../assets/images/png/pelucias/Gund Drops Ginny.png";
import pelucia10 from "../../assets/images/png/pelucias/Gund Drops Webster.png";
import pelucia11 from "../../assets/images/png/pelucias/Gund Drops Winnie.png";
import pelucia12 from "../../assets/images/png/pelucias/Gund Pawpatrol.png";
import pelucia13 from "../../assets/images/png/pelucias/Hello Kitty Carebear.png";
import pelucia14 from "../../assets/images/png/pelucias/Kakashi.png";
import pelucia15 from "../../assets/images/png/pelucias/Kuromi.png";
import pelucia16 from "../../assets/images/png/pelucias/Minecraft.png";
import pelucia17 from "../../assets/images/png/pelucias/My Little Pony.png";
import pelucia18 from "../../assets/images/png/pelucias/Naruto.png";
import pelucia19 from "../../assets/images/png/pelucias/Pull Pals.png";
import pelucia20 from "../../assets/images/png/pelucias/Clawz The Z Gang Eli.png";
import pelucia21 from "../../assets/images/png/pelucias/Clawz The Z Gang Maru.png";
import pelucia22 from "../../assets/images/png/pelucias/Clawz The Z Gang Chloe.png";
import pelucia23 from "../../assets/images/png/pelucias/Clawz The Z Gang Yao.png";
import pelucia24 from "../../assets/images/png/pelucias/Clawz The Z Gang Hopples.png";

const pelucias = [
  {
    src: pelucia1,
    name: "Animal Crossing Mocchi",
  },
  {
    src: pelucia2,
    name: "Animal Hello Kitty",
  },
  {
    src: pelucia3,
    name: "Axolotl Hello Kitty",
  },
  {
    src: pelucia4,
    name: "Beetlejuice",
  },
  {
    src: pelucia5,
    name: "Bluey Squishy Cloud",
  },
  {
    src: pelucia6,
    name: "Carebear Hello Kitty",
  },
  {
    src: pelucia7,
    name: "Dragon Hello Kitty",
  },
  {
    src: pelucia8,
    name: "Fruit Hello Kitty",
  },
  {
    src: pelucia9,
    name: "Gund Drops Ginny",
  },
  {
    src: pelucia10,
    name: "Gund Drops Webster",
  },
  {
    src: pelucia11,
    name: "Gund Drops Winnie",
  },
  {
    src: pelucia12,
    name: "Gund Pawpatrol",
  },
  {
    src: pelucia13,
    name: "Hello Kitty Carebear",
  },
  {
    src: pelucia14,
    name: "Kakashi",
  },
  {
    src: pelucia15,
    name: "Kuromi",
  },
  {
    src: pelucia16,
    name: "Minecraft",
  },
  {
    src: pelucia17,
    name: "My Little Pony",
  },
  {
    src: pelucia18,
    name: "Naruto",
  },
  {
    src: pelucia19,
    name: "Pull Pals",
  },
  {
    src: pelucia20,
    name: "Clawz The Z Gang Eli",
  },
  {
    src: pelucia21,
    name: "Clawz The Z Gang Maru",
  },
  {
    src: pelucia22,
    name: "Clawz The Z Gang Chloe",
  },
  {
    src: pelucia23,
    name: "Clawz The Z Gang Yao",
  },
  {
    src: pelucia24,
    name: "Clawz The Z Gang Hopples",
  },
];

export default function Kawaii() {
  const navigate = useNavigate();
  const swiperRef = useRef(null);

  const handlePrevClick = () => {
    if (swiperRef.current?.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const handleNextClick = () => {
    if (swiperRef.current?.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  return (
    <div>
      <div className="kawaii-container position-relative">
        {/* Background Decoration */}
        <div className="meiaLua">
          <div className="quadradoLua"></div>
        </div>

        {/* Main Content */}
        <div className="container container-kawaii">
          {/* Title Section */}
          <div className="row justify-content-center">
            <div className="col-12 text-center d-flex justify-content-center align-items-center">
              <img
                className="setaCards"
                src={setaEsquerda}
                alt="Previous plush collection slide"
                onClick={handlePrevClick}
              />
              <h1 className="kawaii-title ">See what's dropping!</h1>
              <img
                className="setaCards"
                src={setaDireita}
                alt="Next plush collection slide"
                onClick={handleNextClick}
              />
            </div>
          </div>

          {/* Swiper Component */}
          <Swiper
            ref={swiperRef}
            style={{ padding: "10px", width: "80%" }}
            pagination={{
              clickable: true,
            }}
            loop={true}
            slidesPerView={1}
            spaceBetween={30}
            autoplay={{
              delay: 9000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }}
            modules={[Autoplay]}
            className="mySwiper"
          >
            {pelucias.map((pelucia, index) => (
              <SwiperSlide key={index}>
                <div className="kawaii-card">
                  <img
                    width={"100%"}
                    src={pelucia.src}
                    alt={`${pelucia.name} - Exclusive Clawz Plush Collection`}
                  />
                </div>
                <h2 className="kawaii-card-title">{pelucia.name}</h2>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Title Image */}
          <div className="d-flex justify-content-center">
            <img
              width={"40%"}
              src={tituloKawaii}
              alt="Meet the Z Gang - Exclusive Clawz Plush Collection"
            />
          </div>
        </div>
      </div>
      <div className="kawaii-container-baixo ">
        <div className="container py-5">
          <div className="d-sm-flex d-none flex-sm-row flex-column justify-content-between">
            <img
              className="card-texto-content-img py-3"
              width={"46%"}
              src={texto4}
              alt="Clawz Plush Collection - Premium Plush Toys"
            />
            <img
              className="card-texto-content-img py-3"
              width={"46%"}
              src={texto5}
              alt="Clawz Entertainment - Best Plush Machine Experience"
            />
          </div>
          <div className="d-flex d-sm-none flex-sm-row flex-column justify-content-between">
            <img
              className="card-texto-content-img py-3"
              width={"100%"}
              src={texto4}
              alt="Clawz Plush Collection - Premium Plush Toys"
            />
            <img
              className="card-texto-content-img py-3"
              width={"100%"}
              src={texto5}
              alt="Clawz Entertainment - Best Plush Machine Experience"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
